import { ApiProductType } from '../../../../types/ProductTypes';
import type { Deal } from '../../../types/Deal';
import { Widget } from '../../../types/Widget';
import { WidgetType } from '../../../types/WidgetType';
import Localiser from '../../Localiser';

import getCTA from './getCTA';

export const addCtaToDeal = ({
  deal,
  widget,
  localiser,
  localisedLinkText,
  showPrice,
}: {
  deal: Deal;
  widget: Widget;
  localiser: Localiser;
  localisedLinkText: string;
  showPrice: string;
}): Deal => {
  let cta;

  // we do not want to add custom cta for fallback offers
  if (deal.product_type === ApiProductType.fallback && localisedLinkText) {
    return deal;
  }

  if (widget.type === WidgetType.DEAL || widget.type === WidgetType.ANF_DEAL) {
    cta = localisedLinkText;
  } else {
    cta = getCTA(localiser, widget, { ...deal }, localisedLinkText, showPrice);
  }

  if (cta) {
    return {
      ...deal,
      offer: {
        ...deal.offer,
        merchant_link_text: cta,
        link_text: cta,
      },
    };
  }

  return deal;
};
